import React from 'react';

function Triangle(){
    return(
        <svg version="1.1" id="triangle" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">    
            <polygon className="st0" points="25,5.9 36.5,25.8 48,45.7 25,45.7 2.1,45.7 13.5,25.8 "/>
        </svg>
    )
}

export default Triangle;